import { Button } from "antd";
import React from "react";
import { $t } from "~/i18n.js";
import "./404_not_found.css";

export class NotFound extends React.Component {
  render() {
    return (
      <div className="not_found">
        <h2>404.</h2>
        <p>{$t("Pagina niet gevonden.")}</p>

        <Button
          className="homeButton"
          type="primary"
          onClick={() => (window.location.href = "/")}
        >
          {$t("Terug")}
        </Button>
      </div>
    );
  }
}
